import React, { useCallback, useEffect, useMemo, useState } from 'react';

import { withSiteMap, allSiteMap, processor } from '@bingads-webui-campaign-react/with-site-map';

import { useCalloutStore } from './callout-store';
import { CalloutWithSiteMap } from './callout-with-site-map';

const calloutProcessors = [processor.processPermissions, processor.processPath];

export const CalloutService = () => {
  const [autoNext, setAutoNext] = useState(false);
  const calloutStore = useCalloutStore();

  const calloutList = useMemo(() => calloutStore.queue || [], [calloutStore.queue]);

  const currentEntity = useMemo(() => calloutList[0] || null, [calloutList]);

  const autoHideTimer = useMemo(() => {
    if (currentEntity && currentEntity.timeout > -1) {
      return setTimeout(() => {
        setAutoNext(true);
      }, currentEntity.timeout);
    }

    return null;
  }, [currentEntity]);

  const CurrentCallout = useMemo(() => {
    if (currentEntity) {
      return withSiteMap(
        CalloutWithSiteMap,
        calloutProcessors,
        allSiteMap,
        currentEntity.sitemapId
      );
    }

    return null;
  }, [currentEntity]);

  const nextInner = useCallback((justSkip) => {
    if (currentEntity) {
      calloutStore.next(currentEntity.name, justSkip);
      if (autoHideTimer) {
        clearTimeout(autoHideTimer);
      }
    }
  }, [autoHideTimer, calloutStore, currentEntity]);

  const onNext = useCallback(() => {
    nextInner(false);
  }, [nextInner]);

  const onSkip = useCallback(() => {
    nextInner(true);
  }, [nextInner]);

  useEffect(() => {
    if (autoNext) {
      onNext();
      setAutoNext(false);
    }
  }, [autoNext, onNext]);

  return (
    <div className="callout-service">
      {
        currentEntity && CurrentCallout ?
          <CurrentCallout calloutEntity={currentEntity} onNext={onNext} onSkip={onSkip} />
        : null
      }
    </div>
  );
};
